import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Bar, mixins } from 'vue-chartjs';
import { IRealtimeStat } from '../../interfaces/IRealtimeStat';
import { round2 } from '../../utils';

@Component({
  extends: Bar, // this is important to add the functionality to your component
  mixins: [mixins.reactiveProp],
})
export default class BarChart extends Vue<Bar> {
  @Prop() chartData;
  firstTime = true;

  mounted() {
    this.draw();
  }

  @Watch('chartData')
  onDataChanged() {
    this.draw();
  }

  draw() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    const maxes = [],
      yAxes = [];
    let index = 1;
    for (const dataset of this.chartData.datasets) {
      dataset.yAxisID = index + '';
      let maxVal = 0;
      for (const val of dataset.data) {
        if (val > maxVal) maxVal = val;
      }

      let max = 0;
      if (maxVal === 0) {
        max = 10;
      } else if (maxVal < 10) {
        max = Math.ceil(maxVal / 2) * 2;
      } else if (maxVal < 100) {
        max = Math.ceil(maxVal / 10) * 10;
      } else {
        max = Math.ceil(maxVal / 100) * 100;
      }
      maxes.push(max);
      yAxes.push({
        id: index + '',
        display: index === 1,
        position: 'right',
        type: 'linear',
        gridLines: {
          display: true,
        },
        ticks: {
          stepSize: max / 2,
          beginAtZero: true,
          max,
        },
      });

      index++;
    }

    let total = 0;

    this.renderChart(this.chartData, {
      responsive: true,
      maintainAspectRatio: false,
      title: {
        display: false,
      },
      legend: {
        display: false,
      },
      animation: {
        duration: this.firstTime ? 1000 : 0,
      },
      tooltips: {
        mode: 'index',
        intersect: false,
      },
      hover: {
        mode: 'nearest',
        intersect: true,
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false,
            },
            ticks: {
              beginAtZero: true,
            },
          },
        ],
        yAxes,
      },
    });

    this.firstTime = false;
  }
}
